import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';
import { ChevronLeft, ChevronRight, Check } from 'lucide-react';
import { FaCheck } from "react-icons/fa6";
// import CurrentStateCard from "../Identity/CurrentYou/CompletionPages/CurrentStateCard.jsx"
import { UserContext } from "../../../../../UserContext.js";
// import ProfileCard from "../../widgets/Identity/CurrentYou/ProfileCard.jsx";
import CurrentStateProfileCard from "../../../components/widgets/Identity/CurrentYou/CompletionPages/CurrentStateProfileCard.jsx";
import { progressService } from "../../../../../services/progressService.js";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import Confetti from "react-confetti";

// Import your images
import connectionBelonging from "../../../../../assets/ConnectionandBelongingImg.png";
import financialSecurity from "../../../../../assets/FinancialSecurityImg.png";
import recognitionAppreciation from "../../../../../assets/RecognitionandAppreciationImg.png";
import collaborationCooperation from "../../../../../assets/CollaborationandCooperationImg.png";
import inclusion from "../../../../../assets/InclusionImgage.png";
import supportAndEmpathy from "../../../../../assets/SupportAndEmpImg.png";
import statusAndRespect from "../../../../../assets/StatusResImg.png";
import communication from "../.././../../../assets/CommImg.png";
import autonomyWithinAGroup from "../../../../../assets/AutonomyImage.png";
import meaningfulRelationships from "../../../../../assets/MeaningfulRelImg.png";
import attention from "../../../../../assets/AttentionImage.png";
import workSatisfaction from "../../../../../assets/SatisficationImage.png";
import regulationIcon from "../../../../../assets/regulationsIcon.png";
import CelebrationPage from './CelebrationPage.jsx';
import LastPage from './LastPage.jsx';
// import YourUnmetNeeds from './YourUnmetNeeds.jsx';

const unmetNeedsData = [
  {
    id: 1,
    label: "Connection & Belonging",
    explanation: "Feeling part of a team or organization",
    image: connectionBelonging,
    total: "1/12"
  },
  {
    id: 2,
    label: "Financial Security",
    explanation: "To feel safe and secure at work place",
    image: financialSecurity,
    total: "2/12"
  },
  {
    id: 3,
    label: "Recognition and Appreciation",
    explanation: "Receiving praise and positive feedback for achievements",
    image: recognitionAppreciation,
    total: "3/12"
  },
  {
    id: 4,
    label: "Collaboration and Cooperation",
    explanation: "Opportunities to work, share ideas, and problem-solve together",
    image: collaborationCooperation,
    total: "4/12"
  },
  {
    id: 5,
    label: "Inclusion",
    explanation: "To feel safe and secure at work place",
    image: inclusion,
    total: "5/12"
  },
  {
    id: 6,
    label: "Support and Empathy",
    explanation: "Experiencing genuine care from managers and team members",
    image: supportAndEmpathy,
    total: "6/12"
  },
  {
    id: 7,
    label: "Status and Respect",
    explanation: "Feeling valued and respected by peers and leadership",
    image: statusAndRespect,
    total: "7/12"
  },
  {
    id: 8,
    label: "Communication",
    explanation: "Open, clear, and respectful exchanges among colleagues",
    image: communication,
    total: "8/12"
  },
  {
    id: 9,
    label: "Autonomy within a Group",
    explanation: "Ability to contribute and make decisions collaboratively.",
    image: autonomyWithinAGroup,
    total: "9/12"
  },
  {
    id: 10,
    label: "Meaningful Relationships",
    explanation: "Building workplace friendships and positive relationships",
    image: meaningfulRelationships,
    total: "10/12"
  },
  {
    id: 11,
    label: "Attention",
    explanation: "Having one's contributions acknowledged by others",
    image: attention,
    total: "11/12"
  },
  {
    id: 12,
    label: "Work Satisfaction",
    explanation: "Finding fulfillment in meaningful work and feeling valued",
    image: workSatisfaction,
    total: "12/12"
  },
];

const UnmetNeedsPage = ({ formData, userId, subsectionId, onComplete, initialData, course, onSelectModule, onSelectSubsection, ...otherProps  }) => {
    // ✅ Store subsectionId in a ref so it persists across re-renders
  const subsectionIdRef = useRef(subsectionId);

    // ✅ Update ref if prop changes
  useEffect(() => {
    if (subsectionId) {
      subsectionIdRef.current = subsectionId;
    }
  }, [subsectionId]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
    console.log("UnmetNeedsPage props:", { 
      userId, 
      subsectionId, 
      formData,
      initialData,
      otherProps,
    });
  }, [userId, subsectionId, formData, initialData, otherProps]);

  const [currentIndex, setCurrentIndex] = useState(2);
  const [isAnimating, setIsAnimating] = useState(false);
  const [visibleCardCount, setVisibleCardCount] = useState(3);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [modalData, setModalData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [modalTitle, setModalTitle] = useState("");
  const [selectedCards, setSelectedCards] = useState([]);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [notification, setNotification] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [statusMessages, setStatusMessages] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [isSaving, setIsSaving] = useState(false);

  // NEW: Only these 3 states added for auto-hide and flow
  const [currentStep, setCurrentStep] = useState('selection');
  const [cardMessages, setCardMessages] = useState({});
  const messageTimersRef = useRef({});
  const { user } = useContext(UserContext);

    // ✅ FALLBACK: Use user from context if userId prop is missing
  const effectiveUserId = userId || user?.user_id;

  // ✅ Ensure carousel starts centered on first actual card
  useEffect(() => {
    setTimeout(() => {
      setCurrentIndex(2); // middle card is the first unmetNeed
    }, 100); // small delay ensures render happens
  }, []);


  // ✅ ADD validation
  useEffect(() => {
    if (!effectiveUserId) {
      console.error("❌ No userId available in UnmetNeedsPage");
    }
    if (!subsectionId) {
      console.error("❌ No subsectionId available in UnmetNeedsPage");
    }
  }, [effectiveUserId, subsectionId]);

  // ✅ UPDATE: Load previously saved data
  useEffect(() => {
    if (!effectiveUserId || !subsectionId) {
      console.log("Skipping load - missing userId or subsectionId");
      return;
    }

    const loadProgress = async () => {
      try {
        console.log("Loading progress for:", { effectiveUserId, subsectionId });
        const progress = await progressService.getUserProgress(effectiveUserId, subsectionId);
        console.log("Loaded progress:", progress);
        
        if (progress?.data?.selectedCards) {
          setSelectedCards(progress.data.selectedCards);
        }
      } catch (err) {
        console.error("Failed to load progress:", err);
      }
    };

    loadProgress();
  }, [effectiveUserId, subsectionId]);
  
  // const userName =
  //   user?.firstName && user?.lastName
  //     ? `${user.firstName} ${user.lastName}`
  //     : user?.firstName || user?.lastName || "";

    // ✅ ADD useEffect to load previously saved data
  useEffect(() => {
    if (!userId || !subsectionId) return;

    const loadProgress = async () => {
      try {
        const progress = await progressService.getUserProgress(userId, subsectionId);
        if (progress?.data?.selectedCards) {
          setSelectedCards(progress.data.selectedCards);
        }
      } catch (err) {
        console.error("Failed to load progress:", err);
      }
    };

    loadProgress();
  }, [userId, subsectionId]);
  
  const scrollContainerRef = useRef(null);
  // const cardGap = 30;
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  // Create extended array for infinite scroll effect
  const extendedUnmetNeeds = [
    ...unmetNeedsData.slice(-2),
    ...unmetNeedsData,
    ...unmetNeedsData.slice(0, 2),
  ];

  useEffect(() => {
  if (notification) {
    const timer = setTimeout(() => setNotification(null), 3000);
    return () => clearTimeout(timer);
  }
}, [notification]);

  // NEW: Cleanup timers on unmount
  // useEffect(() => {
  //   return () => {
  //     Object.values(messageTimersRef.current).forEach(timer => clearTimeout(timer));
  //   };
  // }, []);

  useEffect(() => {
  const timersRef = messageTimersRef.current; // ✅ copy current ref value

  return () => {
    Object.values(timersRef).forEach(timer => clearTimeout(timer));
  };
}, []);


  // Update visible card count based on screen size
  useEffect(() => {
    const updateCardCount = () => {
      const width = window.innerWidth;
      if (width < 768) setVisibleCardCount(1);
      else if (width < 1024) setVisibleCardCount(3);
      else setVisibleCardCount(5);
    };

    updateCardCount();
    window.addEventListener("resize", updateCardCount);
    return () => window.removeEventListener("resize", updateCardCount);
  }, []);
  
  const getVisibleCards = () => {
    const half = Math.floor(visibleCardCount / 2);
    const cards = [];
    
    for (let i = -half; i <= half; i++) {
      const idx = currentIndex + i;
      if (idx >= 0 && idx < extendedUnmetNeeds.length) {
        cards.push({
          ...extendedUnmetNeeds[idx],
          position: i,
          index: idx,
        });
      }
    }
    return cards;
  };

  // Navigation functions
  const goToNext = useCallback(() => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prev) => {
      const next = prev + 1;
      if (next >= extendedUnmetNeeds.length - 2) {
        setTimeout(() => {
          setIsAnimating(false);
          setCurrentIndex(2);
        }, 500);
        return next;
      }
      setTimeout(() => setIsAnimating(false), 500);
      return next;
    });
  }, [isAnimating, extendedUnmetNeeds.length]);

  const goToPrevious = useCallback(() => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prev) => {
      const next = prev - 1;
      if (next < 2) {
        setTimeout(() => {
          setIsAnimating(false);
          setCurrentIndex(extendedUnmetNeeds.length - 3);
        }, 500);
        return next;
      }
      setTimeout(() => setIsAnimating(false), 500);
      return next;
    });
  }, [isAnimating, extendedUnmetNeeds.length]);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 75) {
      goToNext();
    }
    if (touchStart - touchEnd < -75) {
      goToPrevious();
    }
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') goToPrevious();
      if (e.key === 'ArrowRight') goToNext();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isAnimating, goToNext, goToPrevious]);

  const isCardSelected = (cardId) => {
    return selectedCards.includes(cardId);
  };

  //  Auto navigate from ProfileCard → CelebrationPage after 5 seconds
  useEffect(() => {
    if (currentStep === 'profile') {
      const timer = setTimeout(() => {
        setCurrentStep('celebration');
      }, 5000); // 5 seconds

      return () => clearTimeout(timer);
    }
  }, [currentStep]);

  // Update the handleCardClick function to accept position parameter
const handleCardClick = (card, position = 0) => {
  // Only allow selection if card is in center position (position === 0)
  if (position !== 0) {
    return; // Do nothing if not center card
  }

  const cardId = card.id;
  const isCurrentlySelected = selectedCards.includes(cardId);

  // Cancel existing timer if any
  if (messageTimersRef.current[cardId]) {
    clearTimeout(messageTimersRef.current[cardId]);
  }

  // Update selection state
  const updatedSelection = isCurrentlySelected
    ? selectedCards.filter(id => id !== cardId)
    : [...selectedCards, cardId];

  setSelectedCards(updatedSelection);

  // Set message
  setCardMessages(prev => ({
    ...prev,
    [cardId]: isCurrentlySelected ? "deselected" : "selected"
  }));

  // Auto-hide message after 3 seconds
  messageTimersRef.current[cardId] = setTimeout(() => {
    setCardMessages(prev => ({
      ...prev,
      [cardId]: null
    }));
  }, 3000);
};

    const handleSubmit = async () => {
    if (selectedCards.length === 0) {
      console.log("No cards selected");
      return;
    }
    
    const currentSubsectionId = subsectionIdRef.current;
    
    // ✅ Validate before saving
    if (!effectiveUserId) {
      console.error("Cannot save: No userId available");
      alert("Error: User not authenticated. Please refresh the page.");
      return;
    }
    
    if (!currentSubsectionId) {
      console.error("Cannot save: No subsectionId available");
      console.log("subsectionId prop:", subsectionId);
      console.log("subsectionIdRef:", subsectionIdRef.current);
      alert("Error: Invalid subsection. Please try again.");
      return;
    }
    
    setIsSaving(true);
    
    try {
      console.log("💾 Saving progress:", { 
        effectiveUserId, 
        currentSubsectionId, 
        selectedCardsCount: selectedCards.length 
      });

      const result = await progressService.saveProgress(
        effectiveUserId,
        currentSubsectionId,  // ✅ Use from ref
        {
          selectedCards: selectedCards,
          selectedCardsData: selectedCards.map(cardId => {
            const card = unmetNeedsData.find(c => c.id === cardId);
            return {
              id: card.id,
              label: card.label,
              explanation: card.explanation,
              image: card.image
            };
          }),
          completedAt: new Date().toISOString()
        },
        "completed"
      );

      console.log("✅ Progress saved successfully:", result);
      setCurrentStep('profile');
      
      if (onComplete) {
        onComplete();
      }
    } catch (err) {
      console.error("❌ Failed to save progress:", err);
      alert("Failed to save your selections. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  // NEW: Handle flow navigation
  const handleNextStep = () => {
    if (currentStep === 'profile') {
      setCurrentStep('celebration');
    } else if (currentStep === 'celebration') {
    //   setCurrentStep('profile');
    // } else if (currentStep === 'profile') {
      setCurrentStep('last');
    }
  };

  // ✅ Combine profile + celebration with 3D rotation + Confetti when CelebrationPage appears
if (currentStep === 'profile' || currentStep === 'celebration') {
  return (
    <div className="relative w-full flex justify-center min-h-[85vh] perspective-[1200px] overflow-hidden">
      {/* 🎉 Confetti when CelebrationPage is active */}
      {currentStep === "celebration" && (
        <Confetti
          recycle={false}
          numberOfPieces={300}
          gravity={0.3}
          tweenDuration={5000}
          className="absolute inset-0"
        />
      )}

      {/* 🔄 3D Flip Container */}
      <div
        className={`relative w-full max-w-4xl h-auto transition-transform duration-[1200ms] transform-style-preserve-3d ${
          currentStep === 'celebration' ? 'rotate-y-180' : ''
        }`}
      >
        {/* 🧍 Front Side → CurrentStateProfileCard */}
        <div className="absolute inset-0 backface-hidden">
          <CurrentStateProfileCard
            formData={formData}
            editableName={false}
            headerLabel="Current State"
            userId={effectiveUserId}
            subsectionId={subsectionIdRef.current}
          />
        </div>

        {/* 🎉 Back Side → CelebrationPage */}
        <div className="absolute inset-0 rotate-y-180 backface-hidden">
          <CelebrationPage
            selectedCards={selectedCards}
            onNext={handleNextStep}
            onBack={() => setCurrentStep('selection')}
            unmetNeedsData={unmetNeedsData}
            userId={effectiveUserId}
            subsectionId={subsectionIdRef.current}
          />
        </div>
      </div>
    </div>
  );
}

  // Render last page
  if (currentStep === 'last') {
    return (
      <LastPage 
        selectedCards={selectedCards}
        unmetNeedsData={unmetNeedsData}
        onBack={() => setCurrentStep('celebration')}
        // onNextSection={handleNextSection}
        userId={effectiveUserId}
        subsectionId={subsectionIdRef.current}
        course={course}
        onSelectModule={onSelectModule}
        onSelectSubsection={onSelectSubsection}
      />
    );
  }

  // YOUR EXISTING UI CODE - EXACTLY SAME, NO CHANGES
  return (
     <div className="relative">
      <div className="min-h-auto w-full flex flex-col justify-start items-center pt-8 md:pt-12 pb-16">
        <div className="text-center mb-6 max-w-7xl mx-auto px-4">
          {/* Your existing header content */}
          <div className="flex flex-col justify-center mb-6 md:mb-8 px-4 sm:px-6 lg:px-8 min-h-[100px] md:min-h-0 relative">
            <h1 className="text-2xl 2xl:text-[28px] font-medium mb-3 text-[#323232] font-gotham">
              In your current career, what are your unmet needs?
            </h1>
            <p className="text-sm sm:text-base text-[#888888] font-normal font-gotham max-w-2xl mx-auto">
              Select the card which relates to your needs.
            </p>
          </div>

          {/* Cards Container */}
          <div className="w-full max-w-7xl mx-auto mb-8">
            <div className="relative flex items-center justify-center px-12 md:px-16 py-2">
              {/* Left Arrow Button */}
              <button
                onClick={goToPrevious}
                disabled={isAnimating}
                className="absolute left-0 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:shadow-xl transition-shadow duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                aria-label="Previous card"
              >
                <ChevronLeft className="w-6 h-6 text-gray-600" />
              </button>

              {/* Desktop View - Carousel */}
              <div className="hidden md:block w-full overflow-hidden py-4">
                <div
                  ref={scrollContainerRef}
                  className="flex justify-center items-center gap-6"
                  style={{
                    transition: isAnimating
                      ? "transform 0.5s ease-in-out"
                      : "none",
                  }}
                >
                  {getVisibleCards().map((card, idx) => {
                    const { position } = card;
                    const isCenter = position === 0;
                    const isSide = Math.abs(position) === 1;
                    const isEdge = Math.abs(position) === 2;
                    const isSelected = isCardSelected(card.id);
                    const isHovered = hoveredCard === card.id;

                    let scale = 1;
                    let opacity = 1;
                    let translateX = 0;

                    if (isSide) {
                      scale = 0.95;
                      opacity = 0.5;
                    } else if (isEdge) {
                      scale = 0.9;
                      opacity = 0.25;
                      translateX = position === -2 ? 5 : -5;
                    }

                    const labelSize = isCenter
                      ? "text-lg md:text-xl"
                      : isSide
                      ? "text-base"
                      : "text-base";
                    const explanationSize = isCenter
                      ? "text-sm md:text-lg"
                      : isSide
                      ? "text-sm"
                      : "text-sm";

                    return (
                      <div
                        key={`${card.index}-${idx}`}
                        className={`bg-white rounded-[20px] pt-6 relative transition-all duration-500 ${
                          isCenter ? "shadow-xl cursor-pointer" : "shadow-md cursor-not-allowed"
                        }`}
                        style={{
                          width: isCenter ? "300px" : "270px",
                          minWidth: isCenter ? "332px" : "280px",
                          height: isCenter
                            ? "400px"
                            : isEdge
                            ? "320px"
                            : "350px",
                          flexShrink: 0,
                          transform: `scale(${scale}) translateX(${translateX}px)`,
                          opacity,
                          transition: "all 0.5s ease-in-out",
                          border: isHovered || isSelected ? '1px solid #54B0AF' : '1px solid transparent',
                        }}
                        onClick={() => handleCardClick(card, position)}
                        onMouseEnter={() => isCenter && setHoveredCard(card.id)}
                        onMouseLeave={() => setHoveredCard(null)}
                      >
                        <div className="h-full flex flex-col items-center overflow-hidden">
                          {/* Card Number and Checkmark */}
                          <div className="w-full flex justify-between items-center absolute top-4 left-4 right-4">
                            <div className="w-7 h-7 flex items-center justify-center text-black font-gotham font-medium text-sm md:text-[14px]">
                              <p>{card.total}</p>
                            </div>
                            {isSelected && (
                              <div className="w-8 h-8 md:w-7 md:h-7 bg-[#54B0AF] rounded-full flex items-center justify-center absolute top-0 right-8">
                                <FaCheck className="w-5 h-5 md:w-4 md:h-4 text-white" />
                              </div>
                            )}
                          </div>

                          {/* Image */}
                          <div className='flex justify-center items-center'>
                            <img src={card.image} alt={card.label} className='w-60 h-48 object-contain'/>
                          </div>

                        <div className='flex-1 w-full h-full rounded-[20px] transition-all duration-500' style={{
                            background: isHovered 
                            ? 'linear-gradient(180deg, #FFFFFF 0%, #54B0AF 100%)'
                            : isSelected
                            ? 'linear-gradient(180deg, #FFFFFF 0%, #54B0AF 100%)'
                            : 'white',
                        }}>
                          {/* Title */}
                          <div
                            className={`font-bold mb-2 mt-4 text-[#1D1D1D] font-gotham break-words text-center whitespace-normal leading-normal ${labelSize}`}
                          >
                            {card.label}
                          </div>

                          {/* Explanation/Description */}
                          <div
                            className={`font-gotham font-medium text-[#323232] break-words text-center leading-normal overflow-hidden ${explanationSize}`}
                            style={{
                              flexGrow: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: isCenter ? 5 : isSide ? 4 : 3,
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {card.explanation}
                          </div>
                        </div>

                        {/* Bottom message bar */}
                        {cardMessages[card.id] && (
                          <div
                            className={`absolute bottom-0 left-0 right-0 py-2 md:py-3 font-gotham text-center font-medium text-sm rounded-b-[18px] transition-all duration-500
                              ${cardMessages[card.id] === "selected"
                                ? "bg-[#54B0AF] text-white"
                                : "bg-[#B0B0B0] text-white"
                              }`}
                          >
                            {cardMessages[card.id] === "selected"
                              ? "SELECTED UNMET NEED"
                              : "DESELECTED"}
                          </div>
                        )}

                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Mobile View - Show only center card */}
              <div 
                className="md:hidden w-full flex justify-center px-4"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
              >
                <div 
                  className={`bg-white rounded-[20px] shadow-md p-6 w-full max-w-sm min-h-[300px] relative cursor-pointer transition-all duration-300`}
                  style={{
                    background: isCardSelected(extendedUnmetNeeds[currentIndex]?.id)
                      ? 'linear-gradient(135deg, #E0F7F7 0%, #B8E6E6 100%)'
                      : 'white',
                    border: isCardSelected(extendedUnmetNeeds[currentIndex]?.id) 
                      ? '2px solid #54B0AF' 
                      : '2px solid transparent',
                  }}
                  onClick={() => handleCardClick(extendedUnmetNeeds[currentIndex], 0)}
                >
                  <div className="h-full flex flex-col justify-start">
                    <div className="w-full flex justify-between items-center mb-4">
                      <div className="w-7 h-7 flex items-center justify-center">
                        <p>{extendedUnmetNeeds[currentIndex]?.total}</p>
                      </div>
                      {isCardSelected(extendedUnmetNeeds[currentIndex]?.id) && (
                        <div className="w-8 h-8 bg-[#54B0AF] rounded-full flex items-center justify-center">
                          <Check className="w-5 h-5 text-white" />
                        </div>
                      )}
                    </div>

                    {/* Image */}
                    <div className='flex justify-center items-center mb-4'>
                      <img src={extendedUnmetNeeds[currentIndex]?.image} alt={extendedUnmetNeeds[currentIndex]?.label} className='w-48 h-48 object-contain'/>
                    </div>

                    {/* Title */}
                    <div className="font-bold mb-4 text-[#1D1D1D] text-lg font-gotham">
                      {extendedUnmetNeeds[currentIndex]?.label}
                    </div>

                    {/* Description */}
                    <div className="text-sm text-[#323232] font-gotham font-medium leading-relaxed">
                      {extendedUnmetNeeds[currentIndex]?.explanation}
                    </div>

                    {/* Selected Text */}
                    {isCardSelected(extendedUnmetNeeds[currentIndex]?.id) && (
                      <div className="absolute bottom-0 left-0 right-0 bg-[#54B0AF] text-white py-2 text-center font-gotham font-medium text-sm rounded-b-[18px]">
                        SELECTED UNMET NEED
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Right Arrow Button */}
              <button
                onClick={goToNext}
                disabled={isAnimating}
                className="absolute right-0 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:shadow-xl transition-shadow duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                aria-label="Next card"
              >
                <ChevronRight className="w-6 h-6 text-gray-600" />
              </button>
            </div>

             {/* Right side - Navigation buttons (up/down) */}
              <div className="flex items-center justify-end gap-2 absolute right-2 md:right-5 bottom-[8%] md:bottom-[7%]">
                <button
                   disabled={true} 
                  className="inline-flex items-center gap-2 px-2 py-2 font-gotham bg-[#B6B6B6] rounded-full hover:bg-[#54B0AF] font-medium transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                >
                  <FaChevronUp className="w-4 h-4 font-gotham -rotate-90 text-white" />
                </button>
            
                <button
                  onClick={handleSubmit}
                  disabled={selectedCards.length === 0}
                  className="inline-flex items-center gap-2 px-2 py-2 font-gotham bg-[#B6B6B6] rounded-full hover:bg-[#54B0AF] font-medium transition-all disabled:opacity-30"
                >
                  <FaChevronDown className="w-4 h-4 font-gotham -rotate-90 text-white" />
                </button>
              </div>
          </div>
        </div>

        {/* Decorative Icon */}
        <img 
          src={regulationIcon} 
          alt="" 
          className='absolute -bottom-[135px] max-w-[661.37px] max-h-[642.52px] left-[25%] pointer-events-none opacity-50 mt-4' 
        />
      </div>

      {/* Modal for "View All" */}
      {isModalOpen && (
        <div 
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setIsModalOpen(false)}
        >
          <div 
            className="bg-white rounded-2xl max-w-4xl w-full max-h-[80vh] overflow-y-auto p-6 relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-600 hover:text-gray-900 transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Modal Title */}
            <h2 className="text-2xl font-bold text-[#1D1D1D] font-gotham mb-6">
              {modalTitle}
            </h2>

            {/* All Cards Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {modalData.map((item) => (
                <div 
                  key={item.id}
                  className={`rounded-xl p-4 hover:shadow-md transition-all cursor-pointer ${
                    isCardSelected(item.id)
                      ? 'bg-gradient-to-br from-[#E0F7F7] to-[#B8E6E6] border-2 border-[#54B0AF]'
                      : 'bg-gray-50'
                  }`}
                  onClick={() => handleCardClick(item)}
                >
                  <div className="flex justify-between items-start mb-2">
                    <div className="font-bold text-[#1D1D1D] text-base font-gotham">
                      {item.label}
                    </div>
                    {isCardSelected(item.id) && (
                      <div className="w-6 h-6 bg-[#54B0AF] rounded-full flex items-center justify-center flex-shrink-0 ml-2">
                        <Check className="w-4 h-4 text-white" />
                      </div>
                    )}
                  </div>
                  <div className="text-sm text-[#323232] font-gotham">
                    {item.explanation}
                  </div>
                  <div className="mt-2 text-xs text-gray-400 font-gotham">
                    {item.total}
                  </div>
                </div>
              ))}
            </div>

            {/* Modal Submit Button */}
            <div className="flex justify-center mt-6">
              <button
                onClick={() => {
                  setIsModalOpen(false);
                  handleSubmit();
                }}
                disabled={selectedCards.length === 0}
                className={`px-6 py-2 rounded-full font-gotham font-medium text-sm transition-all duration-300 ${
                  selectedCards.length === 0
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-[#54B0AF] text-white hover:bg-[#469F9E]'
                }`}
              >
                Submit {selectedCards.length > 0 && `(${selectedCards.length})`}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UnmetNeedsPage;